import { render } from "./FolderView.vue?vue&type=template&id=2d1c64b8&scoped=true&ts=true"
import script from "./FolderView.vue?vue&type=script&lang=ts"
export * from "./FolderView.vue?vue&type=script&lang=ts"

import "./FolderView.vue?vue&type=style&index=0&id=2d1c64b8&scoped=true&lang=less"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d1c64b8"]])

export default __exports__